import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_holidays_upcoming: FaireCategoryEntity = {
  token: "cat_holidays-upcoming",
  type: "category",
  name: "Upcoming holidays",
  level: 2,
  parentToken: "cat_holidays-seasonal",
  href: "/category/holidays",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
